<template>
  <Container class="w-full">
    <div class="flex flex-col items-center justify-between w-full px-4 py-6 my-12 text-white lg:my-24 lg:p-12 lg:flex-row rounded-3xl"
         :class="`bg-${backgroundGradient}`"
    >
      <div class="flex flex-col items-center space-y-4 lg:space-y-0 lg:space-x-8 lg:flex-row">
        <NuxtImg v-if="image"
                 :src="image"
                 :alt="title || ''"
                 class="object-cover w-28 h-28 rounded-xl"
                 sizes="xs:112px sm:112px md:112px lg:112px xl:112px xxl:112px"
                 loading="lazy"
        />
        <h3 class="text-3xl font-medium text-center lg:text-left">
          {{ title }}
        </h3>
      </div>

      <div class="grid grid-cols-2 mt-6 gap-2 lg:mt-0 md:gap-4">
        <ButtonStore v-for="storeLink in storeLinks"
                     :key="storeLink.id"
                     :store-id="storeLink.id"
                     :url="storeLink.url"
                     class="h-12 lg:h-15"
                     @click="track(storeLink)"
        />
      </div>
    </div>
  </Container>
</template>

<script setup lang="ts">
import type { StoreId } from '~/constants'
import { useNuxtApp } from '#imports'

type StoreLink = {
  id: StoreId
  name: string
  url: string
}

type BlogGameCta = {
  backgroundGradient: string
  title: string
  image: string
  storeLinks: Array<StoreLink>
}

const props = defineProps<BlogGameCta>()
const { $event } = useNuxtApp()

function track(storeLink: StoreLink) {
  $event('Game CTA', {
    props: {
      'Game Title': props.title,
      'Store Name': storeLink.name,
      'Store URL': storeLink.url
    }
  })
}
</script>
